export default __webpack_public_path__ + "static/media/albert-sad.9c1cb12c.svg";